import React from "react";
import ContentItem from "./ContentItem";
import ContentItemLiteral from "./ContentItemLiteral";
import { camelCase, isObject } from "lodash";

function _getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

function _sharedKeyWrapper(WrappedComponent, SharedComponent) {
    const sharedKey = isObject(SharedComponent)
        ? camelCase(_getDisplayName(SharedComponent))
        : SharedComponent;

    class SharedWrapper extends React.Component {
        constructor(props) {
            super(props);
            this.sharedKey = sharedKey;
            this.props = props;
        }

        render() {
            return <WrappedComponent sharedKey={this.sharedKey} {...this.props} />;
        }
    }

    SharedWrapper.displayName = `SharedWrapper(${_getDisplayName(WrappedComponent)})`;
    return SharedWrapper;
}

export function SharedContentItem(SharedComponent) {
    return _sharedKeyWrapper(ContentItem, SharedComponent);
}

export function SharedContentLiteral(SharedComponent) {
    return _sharedKeyWrapper(ContentItemLiteral, SharedComponent);
}

export default {
    SharedContentItem,
    SharedContentLiteral
};